/*!
 * 
 *   eddy-web-sdk v0.0.1
 *   https://github.com/ilandn/eddy-web-sdk
 * 
 *   Copyright (c) Eddy Games
 * 
 *   This source code is licensed under the AGPL-3.0 license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */
!function (e, n) {
  "object" === typeof exports && "object" === typeof module ? module.exports = n() : "function" === typeof define && define.amd ? define("eddy-sdk-web", [], n) : "object" === typeof exports ? exports["eddy-sdk-web"] = n() : e["eddy-sdk-web"] = n();
}(window, function () {
  return function (e) {
    var n = {};

    function __webpack_require__(t) {
      if (n[t]) return n[t].exports;
      var r = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = n, __webpack_require__.d = function (e, n, t) {
      __webpack_require__.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: t
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, n) {
      if (1 & n && (e = __webpack_require__(e)), 8 & n) return e;
      if (4 & n && "object" === typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (__webpack_require__.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(t, r, function (n) {
          return e[n];
        }.bind(null, r));
      }
      return t;
    }, __webpack_require__.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return __webpack_require__.d(n, "a", n), n;
    }, __webpack_require__.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
  }([function (e, n, t) {
    e.exports = t(1);
  }, function (e, n, t) {
    "use strict";

    t.r(n);
    var r = Object.freeze({
      GAME_LOADED: "GAME_LOADED",
      ANSWER_RECEIVED: "ANSWER_RECEIVED",
      QUESTIONS_RECEIVED: "QUESTIONS_RECEIVED",
      QUESTIONS_COMPLETED: "QUESTIONS_COMPLETED"
    }),
        i = r;

    function _defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var o = function () {
      function AnswerReceivedEvent(e, n) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, AnswerReceivedEvent), this.data = e, this.replyTime = n;
      }

      var e, n, t;
      return e = AnswerReceivedEvent, (n = [{
        key: "toJSON",
        value: function value() {
          return {
            name: i.ANSWER_RECEIVED,
            data: {
              answer: this.data,
              replyTime: this.replyTime
            }
          };
        }
      }]) && _defineProperties(e.prototype, n), t && _defineProperties(e, t), AnswerReceivedEvent;
    }();

    function GameLoadedEvent_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var a = function () {
      function GameLoadedEvent(e) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, GameLoadedEvent), this.data = e;
      }

      var e, n, t;
      return e = GameLoadedEvent, (n = [{
        key: "toJSON",
        value: function value() {
          return {
            name: i.GAME_LOADED,
            data: this.data
          };
        }
      }]) && GameLoadedEvent_defineProperties(e.prototype, n), t && GameLoadedEvent_defineProperties(e, t), GameLoadedEvent;
    }();

    function QuestionsCompleted_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var u = function () {
      function QuestionsCompletedEvent(e) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, QuestionsCompletedEvent), this.data = e;
      }

      var e, n, t;
      return e = QuestionsCompletedEvent, (n = [{
        key: "toJSON",
        value: function value() {
          return {
            name: i.QUESTIONS_COMPLETED,
            data: this.data
          };
        }
      }]) && QuestionsCompleted_defineProperties(e.prototype, n), t && QuestionsCompleted_defineProperties(e, t), QuestionsCompletedEvent;
    }();

    function Answer_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var s = function () {
      function Answer(e, n) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, Answer), this._isCorrect = n, this._body = e;
      }

      var e, n, t;
      return e = Answer, (n = [{
        key: "isText",
        value: function value() {
          return !0;
        }
      }, {
        key: "isAudio",
        value: function value() {
          return !1;
        }
      }, {
        key: "isImage",
        value: function value() {
          return !1;
        }
      }, {
        key: "text",
        value: function value() {
          return this._body;
        }
      }, {
        key: "isCorrect",
        value: function value() {
          return this._isCorrect;
        }
      }]) && Answer_defineProperties(e.prototype, n), t && Answer_defineProperties(e, t), Answer;
    }();

    function Question_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var c = function () {
      function Question(e) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, Question), this.json = e;
      }

      var e, n, t;
      return e = Question, (n = [{
        key: "isText",
        value: function value() {
          return !0;
        }
      }, {
        key: "isAudio",
        value: function value() {
          return !1;
        }
      }, {
        key: "isImage",
        value: function value() {
          return !1;
        }
      }, {
        key: "text",
        value: function value() {
          return this.json.data.body;
        }
      }, {
        key: "answers",
        value: function value() {
          var e = this;
          return this.json.data.answers.map(function (n) {
            return new s(n, n === e.json.data.correctAnswer);
          });
        }
      }, {
        key: "toJSON",
        value: function value() {
          return this.json;
        }
      }]) && Question_defineProperties(e.prototype, n), t && Question_defineProperties(e, t), Question;
    }();

    function EddySdk_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var d = function () {
      function EddySdk(e) {
        var n = this;
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, EddySdk), this.dispatcher = e, this.questions = null, this.currentQuestionIndex = 0, this.dispatcher.onNewQuestion(function (e) {
          n.questions = e;
        }), this.questionTime = null;
      }

      var e, n, t;
      return e = EddySdk, (n = [{
        key: "gameLoaded",
        value: function value(e) {
          this.dispatcher.dispatchEvent(new a(e));
        }
      }, {
        key: "injectQuestions",
        value: function value(e) {
          this.questions = e;
        }
      }, {
        key: "checkAnswer",
        value: function value(e) {
          var n = new Date() - this.questionTime;
          return this.dispatcher.dispatchEvent(new o(e, n)), e.isCorrect();
        }
      }, {
        key: "getQuestion",
        value: function value() {
          return this.questionTime = new Date(), null === this.questions ? this.questionFalllback() : this.questions.length > this.currentQuestionIndex ? this.questions[this.currentQuestionIndex++] : (this.dispatcher.dispatchEvent(new u({})), !1);
        }
      }, {
        key: "questionFalllback",
        value: function value() {
          return new c({
            id: -1,
            data: {
              answers: [1, 2, 3, 4],
              body: "1 + 1 =",
              correctAnswer: 2
            }
          });
        }
      }]) && EddySdk_defineProperties(e.prototype, n), t && EddySdk_defineProperties(e, t), EddySdk;
    }();

    function EddyEventDispatcher_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var f = function () {
      function EddyEventDispatcher() {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, EddyEventDispatcher), this.handleEddyPlatformEvents = this.handleEddyPlatformEvents.bind(this), window.addEventListener("message", this.handleEddyPlatformEvents, !1), this.newQuestionCallBack = null;
      }

      var e, n, t;
      return e = EddyEventDispatcher, (n = [{
        key: "dispatchEvent",
        value: function value(e) {
          if (window.self !== window.top) {
            var n = JSON.parse(JSON.stringify(e));
            window.top.postMessage(n, "*");
          }
        }
      }, {
        key: "handleEddyPlatformEvents",
        value: function value(e) {
          if (e.data && e.data.name) switch (console.debug("Eddy platform event received ".concat(JSON.stringify(e.data.name))), e.data.name) {
            case i.QUESTIONS_RECEIVED:
              this.newQuestionCallBack(e.data.data.map(function (e) {
                return new c(e);
              }));
              break;

            default:
              console.debug("Uknown event  ".concat(JSON.stringify(e)));
          }
        }
      }, {
        key: "onNewQuestion",
        value: function value(e) {
          this.newQuestionCallBack = e;
        }
      }]) && EddyEventDispatcher_defineProperties(e.prototype, n), t && EddyEventDispatcher_defineProperties(e, t), EddyEventDispatcher;
    }();

    function QuestionsReceivedEvent_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var l = function () {
      function QuestionsReceivedEvent(e) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, QuestionsReceivedEvent), this.data = e;
      }

      var e, n, t;
      return e = QuestionsReceivedEvent, (n = [{
        key: "toJSON",
        value: function value() {
          return {
            name: i.QUESTIONS_RECEIVED,
            data: this.data
          };
        }
      }]) && QuestionsReceivedEvent_defineProperties(e.prototype, n), t && QuestionsReceivedEvent_defineProperties(e, t), QuestionsReceivedEvent;
    }();

    function lib_defineProperties(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    t.d(n, "EddySdk", function () {
      return v;
    }), t.d(n, "EVENTS_NAME", function () {
      return i;
    }), t.d(n, "QuestionsReceivedEvent", function () {
      return l;
    }), t.d(n, "Question", function () {
      return c;
    }), t.d(n, "Answer", function () {
      return s;
    });
    var p = null;

    function getSdkInstance() {
      return null === p && (p = new d(new f())), p;
    }

    var v = new (function () {
      function EddySdkWrapper() {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, EddySdkWrapper);
      }

      var e, n, t;
      return e = EddySdkWrapper, (n = [{
        key: "gameLoaded",
        value: function value(e) {
          return getSdkInstance().gameLoaded(e);
        }
      }, {
        key: "checkAnswer",
        value: function value(e) {
          return getSdkInstance().checkAnswer(e);
        }
      }, {
        key: "getQuestion",
        value: function value() {
          return getSdkInstance().getQuestion();
        }
      }, {
        key: "injectQuestions",
        value: function value(e) {
          return getSdkInstance().injectQuestions(e);
        }
      }]) && lib_defineProperties(e.prototype, n), t && lib_defineProperties(e, t), EddySdkWrapper;
    }())();
  }]);
});